<template>
    <div class="textarea-editor">
       
       
        <p 
            class="textarea" 
            placeholder="Ajoutez votre texte" 
            contenteditable="true" 
            spellcheck="false"
            :ref="`textareaRef${id}`" 
            v-html="textareaValue" 
           
            @input="handlerInput" 
            @click="handlerClick"
            @dblclick="handlerDbClick"
            @focus="handlerOnFocus"
            @blur="handlerOnBlur"
            @keydown="handlerKeyDown"

            @keyup.right="saveSelectedText"
            @keyup.left="saveSelectedText"
            @mouseup="saveSelectedText"

       
            
        ></p>
        <!-- <textarea placeholder="Ajoutez votre texte" ref="textareaRef" v-model="textareaValue" @input="handlerInput" :maxlength="maxCharacters"></textarea> -->
        <div class="textarea-editor-options">
            <div class="left-options">
                <i class="fa-regular fa-face-laugh" @click.self="(e)=>{e.stopPropagation();setDisplayEmojiPicker()}">
                    <Picker
                        :data="emojiIndex"
                        v-show="displayEmojiPicker"
                        @select="addEmoji"
                        ref="emojiPicker"
                        
                    />
                </i>
                <i v-if="showOptionBold" :class="{disable : !selection.contentHtmlSelection}" class="fa-solid fa-bold" @click="styleSelection('bold')"></i>
                <i v-if="showOptionItalic" :class="{disable : !selection.contentHtmlSelection}" class="fa-solid fa-italic" @click="styleSelection('italic')"></i>
                <i v-if="showOptionUnderline" :class="{disable : !selection.contentHtmlSelection}" class="fa-solid fa-underline" @click="styleSelection('underline')"></i>
            </div>

            
            <Tooltip
                position="bottom"
                classCustom="right-options"
                :active="textInfoMaxCharacters.length"
                :text="textInfoMaxCharacters"
            >
                <i v-if="maxCharacters !== Infinity && counterCharacters > maxCharacters" class="fa-solid fa-circle-exclamation"></i>
                <p class="count" v-if="ShowCounterCharacters">
                    <span :class="{red : maxCharacters !== Infinity && counterCharacters > maxCharacters}">{{ counterCharacters }}</span>
                    <template v-if="maxCharacters !== Infinity">
                        /<span>{{ maxCharacters }}</span>
                    </template>
                  
                </p>
              
            </Tooltip>
        </div>
    </div>
</template>

<script>
import Fonts from '../../../utils/Fonts'
import { Picker, EmojiIndex  } from 'emoji-mart-vue-fast'
import emojiData from 'emoji-mart-vue-fast/data/all.json'
import 'emoji-mart-vue-fast/css/emoji-mart.css'
import Tooltip from './../tooltip/tooltipInit.vue'

export default {

    components: {
        Picker,
        Tooltip
    },

    props: {
        id: {
            type: String,
            default: ''
        },

        maxCharacters: {
            type: Number,
            default: Infinity
        },
        showOptionBold: {
            type: Boolean,
            default: true
        },
        showOptionItalic: {
            type: Boolean,
            default: true
        },
        showOptionUnderline: {
            type: Boolean,
            default: true
        }, 
        ShowCounterCharacters: {
            type: Boolean,
            default: true
        },

        textInfoMaxCharacters: {
            type: String,
            default: ''
        },
    },

    data() {
        return {
            
            emojiIndex: new EmojiIndex(emojiData),
            displayEmojiPicker : false,
            counterCharacters: 0,

            isEditable: true,
            cursor : {
                nodeIndex: null,
                startOffset: null,
                endOffset:null,

                previousCursor: {
                    nodeIndex: null,
                    startOffset: null,
                    endOffset:null
                }
            },
            isFocused: false,
            
            selection : {
                selectedText : '',
                selectionStart: null,
                selectionEnd: null,
                contentHtmlSelection: '',
                contentHtmlBeforeSelection: '',
                contentHtmlAfterSelection: ''
            },

            textareaValue: ""
        
        }
    },

    methods: {
        
        handlerInput(e = null, innerHTML = '') {
            console.log('handlerInput')
            if (e) innerHTML = e.target.innerHTML
            this.saveSelectedText()
            this.updateCursorPosition("handelerInput")

            const regex = /(<[^>]+>)|([^<]+)/g;
            let result = '';
            let match;
            // Parcours du contenu avec la regex
            while ((match = regex.exec(innerHTML)) !== null) {
                if (match[1]) {
                    // Si c'est une balise HTML, on la laisse telle quelle
                    result += match[1];
                } else if (match[2]) {
                    // Si c'est du texte normal
                    result += match[2].replace(/(\s|\u00A0)/g, '&nbsp;');
                }
            }

            this.textareaValue = result //(e ? e.target.innerHTML : innerHTML)
            console.log('handlerInput result',result)
            this.$nextTick(() => {
                this.restoreCursorPosition()
                this.$emit('setTextareaValue', result, e ? e : undefined) //e ? e.target.innerHTML : innerHTML, e ? e : undefined)
                this.updateCounterCharacters()
                
            });
        },

        handlerKeyDown(e) {
            console.log("handlerKeyDown")
            // this.updateCursorPosition("handlerKeyDown")
            // const keyForSelection = [37,39,16]
            // if (!keyForSelection.includes(e.keyCode)) {
            //     this.selection.selectedText = ''
            // }
            // this.$emit('keyDown', e)
        },

        handlerOnFocus(e) {
            this.isFocused = true;
        },
        
        handlerOnBlur(e) {
            this.isFocused = false;
            this.textareaValue = e.target.innerHTML
            this.$nextTick(() => {
                this.$emit('onBlurTextarea', e)
            })
        },

        handlerClick(e) {
            this.$emit('clickTextarea', e); 
            this.updateCursorPosition("handlerClick")
        },

        handlerDbClick(e) {
            this.$emit('doubleclickTextarea', e)
        },

        getTextarea() {
            return this.$refs[`textareaRef${this.id}`]
        },

        saveSelectedText() {
            console.log("saveSelectedText")
            function  getHtmlOffset(container, node, offset) {
                const range = document.createRange();
                range.setStart(container, 0);
                range.setEnd(node, offset);
                const div = document.createElement('div');
                div.appendChild(range.cloneContents());
                return div.innerHTML.length;
            }

            const selection = window.getSelection();
            if (selection.rangeCount > 0) {
                
                const range = selection.getRangeAt(0);
                this.selection.selectedText = selection.toString();

                const preSelectionRange = range.cloneRange();
                preSelectionRange.selectNodeContents(this.getTextarea());
                preSelectionRange.setEnd(range.startContainer, range.startOffset);

                const container = this.getTextarea();
                const startOffset = getHtmlOffset(container, range.startContainer, range.startOffset);
                const endOffset = getHtmlOffset(container, range.endContainer, range.endOffset);

                this.selection.selectionStart = startOffset;
                this.selection.selectionEnd = endOffset;

                this.selection.contentHtmlSelection = this.getTextarea().innerHTML.substring(this.selection.selectionStart, this.selection.selectionEnd)
                this.selection.contentHtmlBeforeSelection = this.getTextarea().innerHTML.substring(0, this.selection.selectionStart)
                this.selection.contentHtmlAfterSelection = this.getTextarea().innerHTML.substring(this.selection.selectionEnd)

            }
        },

        updateCounterCharacters() {
            this.counterCharacters = this.getTextarea().innerText.length
        },

        updateCursorPosition(from = undefined) {
           
            const selection = window.getSelection();

            console.log("updateCursorPosition selection", selection.rangeCount)
            if (selection.rangeCount > 0) {

                try{
                    const range = selection.getRangeAt(0);
                    let startContainer = range.startContainer;
                    let nodeIndex = -1
                    console.log("updateCursorPosition startContainer", startContainer, startContainer instanceof HTMLElement)
                    if (startContainer instanceof Text) {
                        const parentNode = startContainer.parentNode.closest('.textarea');
                        while (startContainer.parentNode !== parentNode) {
                            startContainer = startContainer.parentNode;
                        }
                        nodeIndex = Array.from(parentNode.childNodes).indexOf(startContainer);
                    }

                    console.log("updateCursorPosition range", range)

                
                    if (this.cursor.startOffset !== range.startOffset || this.cursor.nodeIndex !== nodeIndex) {
                        this.cursor = {
                            nodeIndex: nodeIndex,
                            startOffset: range.startOffset,
                            endOffset: range.endOffset,

                            previousCursor: {
                                nodeIndex: this.cursor.nodeIndex,
                                startOffset: this.cursor.startOffset,
                                endOffset: this.cursor.endOffset
                            }
                        };
                    }
                } catch (error) {
                    this.cursor = {
                        nodeIndex: this.cursor.nodeIndex -1,
                        startOffset: 0,
                        endOffset: 0,

                        previousCursor: {
                            nodeIndex: this.cursor.nodeIndex,
                            startOffset: this.cursor.startOffset,
                            endOffset: this.cursor.endOffset
                        }
                    };
                }
                
            }

            console.log("updateCursorPosition",this.cursor.nodeIndex,this.cursor.startOffset,this.cursor.endOffset)
        },
        
        restoreCursorPosition(restorePreviousCursor = false) {
            console.log("---------------------------- RestoreCursorPosition Start ----------------------------")
            
            this.getTextarea().focus();

            if (restorePreviousCursor && (!this.cursor.previousCursor || !this.cursor.previousCursor.startOffset)) return;
            if (!restorePreviousCursor && (!this.cursor.startOffset)) return;


            const cursor = restorePreviousCursor ? this.cursor.previousCursor : this.cursor
           
            // console.log('cursor nodeIndex',cursor.nodeIndex)
            // console.log('cursor startOffset',cursor.startOffset)
            // console.log('cursor endOffset',cursor.endOffset)
            // console.log('childs',this.getTextarea().childNodes)

            // console.log('childsSelector',cursor.nodeIndex >= 0 ? this.getTextarea().childNodes[cursor.nodeIndex] : this.getTextarea())
            // console.log('childsSelector textContent',cursor.nodeIndex >= 0 ? this.getTextarea().childNodes[cursor.nodeIndex].textContent : 'none')

            let node = cursor.nodeIndex >= 0 ? this.getTextarea().childNodes[cursor.nodeIndex] : this.getTextarea()

            if (cursor.nodeIndex >= 0) {
                while (node.childNodes && node.childNodes[0]) {
                    node = node.childNodes[0]
                }
            }
                

            console.log('--------------------------------------------------------------')
            console.log('node', node)
            console.log('setStart', cursor.startOffset)
            console.log('setEnd', cursor.endOffset)

            const selection = window.getSelection();
            selection.removeAllRanges();

            const range = document.createRange();

            range.setStart(node, cursor.startOffset);
            // range.setEnd(node, cursor.endOffset);
            range.collapse(true);
            selection.addRange(range);
            

            console.log("---------------------------- RestoreCursorPosition End  ----------------------------")
        },

        ///////////////////////////// Style Text /////////////////////////////

        styleSelection(type) {
            if (!['bold','italic','underline'].includes(type)) return

            if (this.selection.contentHtmlSelection) {
                if (this.selection.contentHtmlSelection.includes('tag-mention')) return
                const innerHTML = this.selection.contentHtmlSelection.replace(/&nbsp;/g, ' ');
                const regex = /(<[^>]+>)|([^<]+)/g;
                let result = '';
                
                let match;
                // Parcours du contenu avec la regex
                while ((match = regex.exec(innerHTML)) !== null) {
                    if (match[1]) {
                        // Si c'est une balise HTML, on la laisse telle quelle
                        result += match[1];
                    } else if (match[2]) {
                        // Si c'est du texte normal, on l'envoie à la fonction bold et remplace dans la chaîne
                        result += Fonts[type](match[2]);
                    }
                }
                
                this.textareaValue = this.selection.contentHtmlBeforeSelection + result.replace(/ /g, '&nbsp;') + this.selection.contentHtmlAfterSelection;
            }
            // a.focus();
            // this.$nextTick(() => {
            //     a.setSelectionRange(start, start+styled.length);
            // });
        },

        ///////////////////////////// Emoji /////////////////////////////

        addEmoji (emoji, idx) {
            const textarea = this.getTextarea();
            this.textareaValue = this.selection.contentHtmlBeforeSelection + emoji.native + this.selection.contentHtmlAfterSelection;
            textarea.focus()
            this.setDisplayEmojiPicker(false)
            this.updateCounterCharacters()
        },

        getInputSelection(el) {

            if (el === null) {
                return {start: 0, end: 0}
            }
            var start = 0, end = 0, normalizedValue, range,
            textInputRange, len, endRange;

            if (typeof el.selectionStart == "number" && typeof el.selectionEnd == "number") {
                start = el.selectionStart;
                end = el.selectionEnd;
            } else {
                const selection = window.getSelection();
                range = selection.createRange();

                if (range && range.parentElement() == el) {
                    len = el.value.length;
                    normalizedValue = el.value.replace(/\r\n/g, "\n");

                    // Create a working TextRange that lives only in the input
                    textInputRange = el.createTextRange();
                    textInputRange.moveToBookmark(range.getBookmark());

                    // Check if the start and end of the selection are at the very end
                    // of the input, since moveStart/moveEnd doesn't return what we want
                    // in those cases
                    endRange = el.createTextRange();
                    endRange.collapse(false);

                    if (textInputRange.compareEndPoints("StartToEnd", endRange) > -1) {
                        start = end = len;
                    } else {
                        start = -textInputRange.moveStart("character", -len);
                        start += normalizedValue.slice(0, start).split("\n").length - 1;

                        if (textInputRange.compareEndPoints("EndToEnd", endRange) > -1) {
                            end = len;
                        } else {
                            end = -textInputRange.moveEnd("character", -len);
                            end += normalizedValue.slice(0, end).split("\n").length - 1;
                        }
                    }
                }
            }

            return {
                start: start,
                end: end
            };
        },

        setDisplayEmojiPicker(display = null) {
            if (display == null) display = !this.displayEmojiPicker 
            
            this.displayEmojiPicker = display

            if (display) {
                window.addEventListener('click', this.handleClickOutsideEmojiPicker);
            }else{
                window.removeEventListener("click", this.handleClickOutsideEmojiPicker, false);
            }
        },

        handleClickOutsideEmojiPicker(event) {
            const targetElement = this.$refs["emojiPicker"].$el;

            if (!targetElement.contains(event.target)) {
                window.removeEventListener("click", this.handleClickOutsideEmojiPicker, false);
                this.displayEmojiPicker = false
            }
        },

       

    },


    watch: {
        // ["textareaValue"](newValue) {
        //     this.handlerInput(null, newValue)
        // },
        
    },

    beforeDestroy() {
        window.removeEventListener("click", this.handleClickOutsideEmojiPicker);
    },
}
</script>
